import axios from "axios";

const url = process.env.REACT_APP_API_URL_FILE
const urlPortal = process.env.REACT_APP_API_URL_PORTALKKP

export default class UploadService {
    uploadFile(nomorAju, file) {
        const formData = new FormData()
        formData.append("file", file)
        return axios.post(url + '/upload?nomorAju=' + nomorAju, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    uploadFileFormData(nomorAju, formData){
        return axios.post(url + '/upload?nomorAju=' + nomorAju, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    sendToPortal(jsonData){
        return axios.post(urlPortal + '/upload_prod.php', jsonData,{
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}